import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { CoreCommonModule } from '@core/common.module';

import { DashboardService } from './dashboard.service';

import { DashboardComponent } from './home/dashboard.component';

const routes = [
  {
    path: 'app/dashboard',
    component: DashboardComponent,
    // canActivate: [AuthGuard],
    resolve: {
      css: DashboardService,
    },
    data: { animation: 'decommerce' },
  },
];

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    NgbModule,
    PerfectScrollbarModule,
    CoreCommonModule,
  ],
  providers: [DashboardService],
  exports: [DashboardComponent],
})
export class DashboardModule {}
